module.exports = __webpack_public_path__ + "img/figure-5.622d804b.png";